import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Util } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { Icon } from '@grandvisionhq/icons';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { CartCounter } from '../components/CartCounter/CartCounter.js';
import { GET_TOTAL_LINE_ITEMS } from '../operations/queries/get-total-line-items.js';
import { getUnrecoverableValidationErrors } from '../utils/get-unrecoverable-validation-errors.js';

const CartButtonContainer = ({ href , className , label , tabIndex  })=>{
    const intl = useIntl();
    const { isClearCartOnAllErrorsEnabled  } = useFeatureToggles();
    const [cartData, { setCartCount , reset  }] = useCartStorage();
    const isClient = useIsClient();
    const handleOnCompleted = React.useCallback((data)=>{
        var ref, ref1, ref2, ref3;
        const validationErrors = data === null || data === void 0 ? void 0 : (ref = data.cart) === null || ref === void 0 ? void 0 : ref.validationErrors;
        const failures = data === null || data === void 0 ? void 0 : (ref1 = data.cart) === null || ref1 === void 0 ? void 0 : ref1.failures;
        if (validationErrors && getUnrecoverableValidationErrors(validationErrors).length || (failures === null || failures === void 0 ? void 0 : failures.length)) {
            // If there are unsolvable validation errors, reset the cart
            reset();
            return;
        }
        (data === null || data === void 0 ? void 0 : (ref2 = data.cart) === null || ref2 === void 0 ? void 0 : ref2.cart) && setCartCount(data === null || data === void 0 ? void 0 : (ref3 = data.cart) === null || ref3 === void 0 ? void 0 : ref3.cart.numberOfItems);
    }, [
        setCartCount,
        reset
    ]);
    const [getTotalLineItems] = useLazyQuery(GET_TOTAL_LINE_ITEMS, {
        onCompleted: handleOnCompleted,
        onError: (error)=>{
            console.error(error);
            if (isClearCartOnAllErrorsEnabled) {
                reset();
            }
        }
    });
    const tealiumAttributes = {
        'data-element-id': `MainNav_Bag`
    };
    const ariaLabel = React.useMemo(()=>{
        return cartData.cartCount === 0 ? intl.getLabel('cart.emptyCart.title') : Util.getCartTotalsTitle(cartData.cartCount, intl, 'cart.minicart.totalsTitle.singular', 'cart.minicart.totalsTitle');
    }, [
        cartData.cartCount,
        intl
    ]);
    React.useEffect(()=>{
        if (cartData.cartId) {
            getTotalLineItems({
                variables: {
                    id: cartData.cartId
                }
            });
        }
    }, [
        cartData.cartId,
        getTotalLineItems
    ]);
    if (!isClient) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
        className: classnames('cart-button', className),
        href: href,
        title: label,
        tabIndex: tabIndex,
        "aria-label": tabIndex === -1 ? '' : ariaLabel
    }, tealiumAttributes), /*#__PURE__*/ React.createElement(Icon, {
        name: "shopping-bag"
    }), /*#__PURE__*/ React.createElement(CartCounter, {
        count: cartData.cartCount
    }));
};

export { CartButtonContainer };
//# sourceMappingURL=CartButtonContainer.js.map
